import type { Assessment } from "../assessment-types";

export const PEOPLE_PLEASING_ASSESSMENT: Assessment = {
  slug: "people-pleasing",
  emoji: "🫶",
  title: "People-Pleasing & Fawning",
  tagline: "Saying yes when you mean no",
  intro:
    "This reflects on patterns of people-pleasing and the fawn response, where keeping others happy can come before your own needs. There are no right answers, just patterns worth noticing.",
  questions: [
    { id: "q1", text: "Do you find yourself saying yes to things because you're worried someone will become upset with you?" },
    { id: "q2", text: "Do you agree with people even when you actually think differently?" },
    { id: "q3", text: "Do you apologise for things that aren't really your fault?" },
    { id: "q4", text: "Do you find it hard to ask for what you need?" },
    { id: "q5", text: "Do you notice yourself changing how you act depending on who you're with?" },
    { id: "q6", text: "Do you feel responsible for other people's moods or feelings?" },
    { id: "q7", text: "Do you put other people's needs ahead of your own, even when you're exhausted?" },
    { id: "q8", text: "Do you avoid sharing your opinion in case it causes tension?" },
    { id: "q9", text: "Do you feel anxious when someone seems even slightly annoyed with you?" },
    { id: "q10", text: "Do you find yourself over-explaining or justifying your decisions?" },
    { id: "q11", text: "Do you struggle to say no, even to requests that feel unfair?" },
    { id: "q12", text: "Do you feel more comfortable focusing on others than on yourself?" },
  ],
  bands: [
    {
      key: "low",
      minPercent: 0,
      headline: "Your answers suggest people-pleasing patterns show up rarely for you right now.",
      body:
        "It sounds like you're generally able to hold your own view alongside caring for others. It's still worth staying curious about moments where this might shift.",
    },
    {
      key: "some",
      minPercent: 30,
      headline: "You may recognise some patterns related to people-pleasing and the fawn response.",
      body:
        "Wanting to keep things smooth with others is very human. Noticing where this tips into overriding your own needs is a gentle place to start paying attention.",
    },
    {
      key: "often",
      minPercent: 55,
      headline: "Your answers suggest you may often lean towards people-pleasing and fawning.",
      body:
        "This pattern often develops as a way of staying safe or accepted, especially when conflict once felt risky. It made sense as an adaptation, even if it feels tiring now.",
    },
    {
      key: "high",
      minPercent: 78,
      headline: "Your answers suggest people-pleasing and fawning may be showing up strongly and often.",
      body:
        "Putting others first this consistently can leave little room for your own needs. This pattern usually formed for good reason, and it's possible to gradually make more space for yourself.",
    },
  ],
  next: [
    { label: "Explore boundaries", to: "/learn/boundaries" },
    { label: "Understand trauma responses", to: "/learn/trauma-responses" },
    { label: "Reconnect with your inner child", to: "/learn/inner-child" },
    { label: "Try a guided journal", to: "/guided-journal" },
  ],
};
